export var EField;
(function (EField) {
    EField["CurrentPrice"] = "currentPrice";
    EField["CurrentCommonCosts"] = "currentCommonCosts";
    EField["CurrentNonCommonCosts"] = "currentNonCommonCosts";
    EField["NewCommonCosts"] = "newCommonCosts";
    EField["NewNonCommonCosts"] = "newNonCommonCosts";
    EField["NewPrice"] = "newPrice";
    EField["ActualTotal"] = "actualTotal";
    EField["Retroactivity"] = "retroactivity";
    EField["GenerateLetter"] = "generateLetter";
    EField["LetterType"] = "letterType";
    EField["ForceFullIndexation"] = "forceFullIndexation";
    EField["EpcBasedLimitationInfo"] = "epcBasedLimitationInfo";
    EField["LegallyAdjustedTotal"] = "legallyAdjustedTotal";
    EField["EpcExpirationDate"] = "epcExpirationDate";
})(EField || (EField = {}));
